<cft-content-section [title]="title()" [titleAlignment]="'left'">
  <div class="grid grid-cols-1 gap-x-2xl gap-y-md pr-lg md:grid-cols-2 lg:grid-cols-3">
    @for (item of relatedItems(); track item.id) {
      <cft-list-element truncateLabel [link]="item.link" [label]="item.name" />
    }
  </div>
</cft-content-section>
